import React from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";

const PartnerTypeField = ({
  record,
  source,
  basePath,
  reference,
  ...props
}) => {
  const partnerType = get(record, source);
  const partnerTypeOther = get(record, "partner_type_other", null);
  const value = [partnerType, partnerTypeOther]
    .filter((v) => v !== null)
    .join(" / ");
  return (
    <Typography variant="body2" {...props}>
      {value}
    </Typography>
  );
};
export default PartnerTypeField;
